import {MY_FOOD} from '../types/actions';

const initialState = {}

export default (state = initialState, action) => {
    switch (action.type) {
        case MY_FOOD.GET_MY_FOOD_LIST:
            return { ...state, myFoodList: action.payload };
        default:
            return state
    }
}